/**
 * Created by tayloremolo on 11/4/17.
 */
import React, {Component} from 'react';
import ReactDOM from "react-dom";
import CTA from "../components/cta";

class JoinusSection extends Component {

    render() {

        return (
            <div>

                <div className="section m0 --white z-22">
                    <div className="container p-40 relative-text">
                        <div className="row mb0">
                            <div className="col s12 p0 center-align">
                                <h1 className="f-52 white-text bold-text text-uppercase mb0">
                                    Join Us At
                                    <br/>
                                    <span className="f-84 ls-5 white-text">Disrupt&nbsp;
                                        <span className="brand-text">Puerto&nbsp;Rico</span>
                                    </span>
                                    <br/>
                                    2018 Conference & Hackathon
                                </h1>
                            </div>

                            <div className="col s12 center-align p0">
                                <br/>
                                <CTA/>
                                <br/>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        )

    }

}

export default JoinusSection;


// WEBPACK FOOTER //
// ./src/components/joinus-section.js